import { operatorClient } from 'domain/HttpClients';

export const approve = (profileId, doc) => operatorClient
  .Post(`/api/filecabinet/${profileId}/approve`)
  .withData(doc)
  .send();

export const reject = (profileId, doc) => operatorClient
  .Post(`/api/filecabinet/${profileId}/reject`)
  .withData(doc)
  .send();
